(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["indivisible-reserve"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const link = event.target.closest('.indivisible a[href="#indivisible-buy"], .indivisible a[href="#indivisible-tasting"]');
  if (!link) return;
  const header = document.getElementById('shopify-section-header');
  const headerHeight = header ? header.getBoundingClientRect().height : 0;
  link.dataset.offset = Math.ceil(headerHeight) + 16;
}, true);

  } catch(e) { console.error(e); }
})();
})();
